import React from "react";
import { Link, useLocation } from "react-router-dom";

const TabMenuChain3 = () => {
  const location = useLocation();

  return (
    <>
      <ul>
        <li>
          <Link
            to="/deposit/meta"
            className={`${location.pathname == "/" ? "active" : location.pathname == "/deposit/meta" ? "active" : ""}`}
          >
            Deposit
          </Link>
        </li>
        <li>
          <Link
            to="/withdraw/meta"
            className={`${location.pathname == "/withdraw/meta" ? "active" : ""}`}
          >
            Withdraw
          </Link>
        </li>
      </ul>
    </>
  );
};

export default TabMenuChain3;
